/* ==========================================================================
   SITE HEADER
   ========================================================================== */
(function () {
	var lastScrollY = window.scrollY;
	const header = document.querySelector(".site-header");

	header.addEventListener( "click", function( ev ) {
		if ( "menu-toggle" === ev.target.getAttribute( "id" ) ) {
			toggleState( ev );
		}
	});

	window.addEventListener("scroll", fixedMenu);

	document.addEventListener("DOMContentLoaded", () => {

		const mainMenu = document.querySelector(".site-header__nav-list");
		const menuItems = mainMenu?.querySelectorAll(".menu-item");

		if (menuItems) {
			menuItems.forEach((item) => {
				item.addEventListener("click", (e) => {
					item.classList.toggle("is-hover");
				});
				item.addEventListener("mouseenter", () => {
					item.classList.add("is-hover");
				});
				item.addEventListener("mouseleave", () => {
					item.classList.remove("is-hover");
				});
			});
		}
	});

	function toggleState(e) {
		const button = e.target.closest("button");
		const isExpanded = button.getAttribute("aria-expanded") === "true";
		const controlled = document.getElementById(
			button.getAttribute("aria-controls")
		);
		controlled.classList.toggle("hidden");
		button.setAttribute("aria-expanded", !isExpanded);

		if (window.innerWidth < 800) {
			const spanAccount = document.querySelector(
				".site-header__nav-link--account span"
			);
			spanAccount.classList.toggle("visually-hidden");
		}

		if (window.innerWidth < 1100) {
			document.querySelector("body").style.overflow = isExpanded
				? "auto"
				: "hidden";
			document
				.querySelector("header.site-header")
				.classList.toggle("site-header-active-blur");
		}
	}

	function fixedMenu() {
		if (window.innerWidth < 800) {
			if (window.scrollY < lastScrollY) {
				header.classList.add("fixed");
			} else {
				header.classList.remove("fixed");
			}
			lastScrollY = window.scrollY;
		}
	}
})();

/* ==========================================================================
   SITE LANGUAGE SELECTOR
   ========================================================================== */
(function () {
	document.addEventListener("DOMContentLoaded", async () => {

		if (!document.querySelector(".site-footer__colophon-select-language") || !document.querySelector(".site-footer__colophon-select-language .site-footer__select-language")) {
			return;
		}

		const selectCountrySelected = document.querySelector(".site-footer__colophon-select-language .site-footer__select-language--item-selected");
		const selectCountryItems = document.querySelector(".site-footer__colophon-select-language .site-footer__select-language--items");
		const selectCountryItem = document.querySelector(".site-footer__colophon-select-language .site-footer__select-language--item")

		selectCountrySelected.addEventListener("click", function (event) {
			event.preventDefault();

			selectCountrySelected.classList.add("open");
			selectCountryItems.style.display = "block";
		});

		document.addEventListener("click", function (event) {
			if (!event.target.closest(".site-footer__select-language")) {
				selectCountryItems.style.display = "none";
				selectCountrySelected.classList.remove("open");
			}
		});
	});
})();

/* ==========================================================================
   DISABLE LOG SCRIPT
   ========================================================================== */
if (window.location.hostname === 'www.vivagym.com') {
    console.log = function() {};
    console.error = function() {};
}

/* ==========================================================================
    BACK TO TOP BUTTON
    ========================================================================== */   
(function () {
	document.addEventListener("DOMContentLoaded", () => {

		const img = document.getElementById("vg-nav-arrow");
		if (!img) {
			return;
		}

		window.addEventListener("scroll", function() {
			if (window.scrollY > 100) {
				img.style.display = "block";
			} else {
				img.style.display = "none";
			}
		});
	});
})();

